"use client"
import type React from "react"
import { useMemo, useRef } from "react"
import { createContext } from "use-context-selector"

type SelectItemShortcutsContextType = {
  lastSelectedIndexRef: React.MutableRefObject<number | null>
  lastMultiselectIndexRef: React.MutableRefObject<number | null>
}

export const SelectItemShortcutsContext =
  createContext<SelectItemShortcutsContextType>({
    lastSelectedIndexRef: { current: null },
    lastMultiselectIndexRef: { current: null },
  })

type Props = {
  children: React.ReactNode
}

export const SelectItemShortcutsProvider = ({ children }: Props) => {
  const lastSelectedIndexRef = useRef(null)
  const lastMultiselectIndexRef = useRef(null)

  const value = useMemo(
    () => ({ lastSelectedIndexRef, lastMultiselectIndexRef }),
    [lastSelectedIndexRef],
  )

  return (
    <SelectItemShortcutsContext.Provider value={value}>
      {children}
    </SelectItemShortcutsContext.Provider>
  )
}
